import React from 'react';
import { Switch, Tooltip } from '@mui/material';
import { useSetUserActive } from '../useSetUserActive';

/**
 * The users table's Active switch: on while the user is active; deactivating or activating
 * asks the admin to confirm first (useSetUserActive). Disabled on the admin's own row.
 */
export const UserActiveSwitch = ({ user }) => {
	const { isActive, canChange, isLoading, setActive } = useSetUserActive(user);

	return (
		<Tooltip title={canChange ? '' : 'You cannot deactivate yourself'}>
			{/* The span keeps the tooltip working while the switch is disabled */}
			<span>
				<Switch
					checked={isActive}
					onChange={(event) => setActive(event.target.checked)}
					// Toggling shouldn't also open the row's drawer
					onClick={(event) => event.stopPropagation()}
					disabled={!canChange || isLoading}
					size='small'
					slotProps={{ input: { 'aria-label': `${user.name} active` } }}
				/>
			</span>
		</Tooltip>
	);
};
